var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFindSuppliers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#0E8080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 25.0002L20.6572 20.6572M20.6572 20.6572C21.4001 19.9143 21.9894 19.0324 22.3914 18.0618C22.7935 17.0911 23.0004 16.0508 23.0004 15.0002C23.0004 13.9496 22.7935 12.9093 22.3914 11.9387C21.9894 10.968 21.4001 10.0861 20.6572 9.34321C19.9143 8.60032 19.0324 8.01103 18.0618 7.60898C17.0911 7.20693 16.0508 7 15.0002 7C13.9496 7 12.9093 7.20693 11.9387 7.60898C10.968 8.01103 10.0861 8.60032 9.34321 9.34321C7.84288 10.8435 7 12.8784 7 15.0002C7 17.122 7.84288 19.1569 9.34321 20.6572C10.8435 22.1575 12.8784 23.0004 15.0002 23.0004C17.122 23.0004 19.1569 22.1575 20.6572 20.6572Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindSuppliers);
export default __webpack_public_path__ + "static/media/findSuppliers.bad64bd16541758a693c75df7aa63696.svg";
export { ForwardRef as ReactComponent };